export default {
   'features': 'Возможности',
   'downloads': 'Загрузки',
   'roadmap': 'Дорожная карта',
   'price': 'Стоимость',
   'donate': 'Поддержка',
   'feedback': 'Обратная связь',
   'panel': 'Панель управления',
};
